module.exports = __webpack_public_path__ + "static/img/wechat-qrcode.965729e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wechat-qrcode.png
// module id = miMV
// module chunks = 23